/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum for formula evaluation status, matching the TypeScript enum.
 * @export
 */
export const FormulaEvaluateStatus = {
    Success: 'success',
    Warning: 'warning',
    Error: 'error',
} as const;
export type FormulaEvaluateStatus = typeof FormulaEvaluateStatus[keyof typeof FormulaEvaluateStatus];


export function instanceOfFormulaEvaluateStatus(value: any): boolean {
    for (const key in FormulaEvaluateStatus) {
        if (Object.prototype.hasOwnProperty.call(FormulaEvaluateStatus, key)) {
            if (FormulaEvaluateStatus[key as keyof typeof FormulaEvaluateStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FormulaEvaluateStatusFromJSON(json: any): FormulaEvaluateStatus {
    return FormulaEvaluateStatusFromJSONTyped(json, false);
}

export function FormulaEvaluateStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateStatus {
    return json as FormulaEvaluateStatus;
}

export function FormulaEvaluateStatusToJSON(value?: FormulaEvaluateStatus | null): any {
    return value as any;
}

export function FormulaEvaluateStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FormulaEvaluateStatus {
    return value as FormulaEvaluateStatus;
}

